import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardText,
} from "reactstrap";

export class UserCard extends Component {
  
  render() {

    return (
      <Card className="card-user">
      <CardBody>
        <CardText />
        <div className="author">
          <div className="block block-one" />
          <div className="block block-two" />
          <div className="block block-three" />
          <div className="block block-four" />
          
        <img
        className="avatar"
        src={this.props.avatar}
        alt="..."
      />
            <h5 className="title">{this.props.name}</h5>
          <p className="description">{this.props.website}{this.props.username}</p>
        </div>
        <div className="card-description">
        {this.props.description}
        </div>
      </CardBody>
      <CardFooter>
      {this.props.socials}
      </CardFooter>
      </Card>
    );
  }
}

export default UserCard;
